import {
  ArrowDownCircleIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import AddButton from "../../../../components/AddButton";
import CloseIconButton from "../../../../components/CloseIconButton";
import DynamicTableTS from "../../../../components/tables/DynamicTableTS";
import { selectedModule, selectedReports } from "./atoms";
import useGetDynamicData from "./hooks/useGetDynamicData";
import { CSVLink } from "react-csv";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import MaterialReactTable from "material-react-table";

const DynamicTable = () => {
  const addPermission = PERMISSIONS.permission_utilities_customreport_add;

  const selectedReport = useRecoilValue(selectedReports);
  const userPermissions = useRecoilValue(permissionsSelector);
  const [customReport, setCustomReport] = useState(false);
  const moduleName = useRecoilValue(selectedModule);

  const history = useHistory();

  useEffect(() => {
    const report = localStorage.getItem("Reports");
    if (report === "FromCustomReport") {
      setCustomReport(true);
    }
  }, []);

  const { data: tableData, isFetching } = useGetDynamicData(selectedReport);

  const dataColumn = useMemo(
    () => (tableData ? tableData?.column : []),
    [tableData?.column]
  );

  const dataTable = useMemo(
    () => (tableData ? tableData?.data : []),
    [tableData?.data]
  );

  const exportdata = dataTable?.map(({ tableData, ...x }) => {
    return {
      ...x,
    };
  });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  let reportName = selectedReport?.replace(/\s/g, "");
  const csvReport = {
    filename: reportName + "_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  return (
    <>
      <div className="text-xs items-center">
        {customReport && (
          <div className="relative -top-2 -right-6">
            <CloseIconButton
              onClick={() => {
                history.push({
                  pathname: "/utilitiestabs/CustomReport",
                });

                window.location.reload();
                localStorage.removeItem("Reports");
              }}
            />
          </div>
        )}

        <div className="">
          <div className="mx-4 mt-4 overflow-x-auto">
            <div className="flex mb-2 gap-2 items-center">
              <div>
                <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading-tight">
                <div className="text-gray-500 text-md font-medium font-medium">
                  Report: {selectedReport}
                </div>
                <div className="flex items-center font-bold text-lg text-primary">
                  {selectedReport}
                </div>
              </div>
            </div>
            <div className="flex justify-between flex-row text-xs items-center w-full">
              <div className="text-gray-500 text-sm">
                Total Records:
                <span className="text-primary text-base font-bold"> </span>
                {!isFetching && dataTable?.length > 0 ? dataTable?.length : 0}
              </div>

              <div className="flex items-center gap-2">
                {!isFetching
                  ? userPermissions?.includes(addPermission) && (
                      <AddButton
                        buttonText="Add New Report"
                        className={"opacity-100"}
                        onClick={() => {
                          history.push({
                            pathname: "/utilitiestabs/CustomReport",
                            state: {
                              action: "addNewReport",
                              module: moduleName,
                              reportName: selectedReport,
                            },
                          });
                          window.location.reload();
                        }}
                      />
                    )
                  : ""}
                {!isFetching && (
                  <button
                    className="border-quinary shadow-md  hover:text-white  hover:bg-quinary text-quinary group relative 
                    flex justify-center items-center py-1 px-3 border text-xs font-medium 
                    rounded-full"
                  >
                    <CSVLink {...csvReport}>
                      <ArrowDownCircleIcon className="h-4 w-4 mr-2 inline-block" />
                      Download File
                    </CSVLink>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialReactTable
            columns={!isFetching ? dataColumn : []}
            data={!isFetching ? dataTable : []}
            state={{
              density: "compact",
              isLoading: isFetching,
            }}
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination={!isFetching}
            enableSorting={true}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            muiTableHeadCellProps={{ align: "center" }}
            muiTableBodyCellProps={{ align: "center" }}
          />
        </div>
      </div>
    </>
  );
};

export default DynamicTable;
